import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import CourseSectionStatusService from "../../../Services/CourseSectionStatus.service";
const makeSearchArgs = {
    loadOptions: (search) => CourseSectionStatusService.searchAll(search),
    label: "name",
    value: "id",
};
export const CourseSectionStatusSearch = makeSearch(makeSearchArgs);
export const CourseSectionMultiSearch = makeMultiSearch(makeSearchArgs);
